import Vue from 'vue'
import VueIframe from 'vue-iframes'
import VueMeta from 'vue-meta'
import PortalVue from 'portal-vue'
import { InertiaApp } from '@inertiajs/inertia-vue'
import { InertiaProgress } from '@inertiajs/progress/src'
import { trim } from 'lodash'
import HighchartsVue from 'highcharts-vue'
import $ from 'jquery'
import * as VueGoogleMaps from "vue2-google-maps"
window.moment = require('moment')
Vue.config.productionTip = false
Vue.mixin({ methods: { route: window.route } })
Vue.use(InertiaApp)
Vue.use(PortalVue)
Vue.use(VueMeta)
Vue.use(VueIframe)
Vue.use(HighchartsVue)
const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
Vue.filter('formatDate', function (value) {
  if (!value) return ''
  if (value) {
    return moment(String(value)).format('DD/MM')
  }
  if (typeof value === 'string') {
    value = new Date(value)
  }
  return months[value.getMonth()] + ' ' + value.getDate() + ',' + ' ' + value.getFullYear()
})

Vue.filter('Dateformat', function (value) {
  if (!value) return ''
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
  if (typeof value === 'string') {
    value = new Date(value)
  }
  return months[value.getMonth()] + ' ' + value.getDate() + ',' + ' ' + value.getFullYear()
})

Vue.filter('DateTimeformat', function (value) {
  if (!value) return ''
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY hh:ss a')
  }
  if (typeof value === 'string') {
    value = new Date(value)
  }
  return months[value.getMonth()] + ' ' + value.getDate() + ',' + ' ' + value.getFullYear()
})

Vue.filter('trim', function (value) {
  if (!value) return ''

  return trim(value);
})
InertiaProgress.init({
  delay: 150,
  color: '#0A7E7D',
  includeCSS: true,
  showSpinner: false,
})

// Required for package CSS (npm run dev)
require('/node_modules/vue-multiselect/dist/vue-multiselect.min.css')


let app = document.getElementById('app')

Vue.use(VueGoogleMaps, {
    load: {
      key: "AIzaSyAbi9QJxV9-2i3W_Rt9IJXj8AzgkGPEGWM",
      libraries: "places"
    }
});

new Vue({
  metaInfo: {
    titleTemplate: (title) => title ? `${title} - PulsePlay` : 'PulsePlay'
  },
  render: h => h(InertiaApp, {
    props: {
      initialPage: JSON.parse(app.dataset.page),
      resolveComponent: name => import(`@/Pages/${name}`).then(module => module.default),
    },
  }),
}).$mount(app)
